import React from "react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import {
  GitHub as GitHubIcon,
  LinkedIn as LinkedInIcon,
  Email as EmailIcon,
  Phone as PhoneIcon
} from "@mui/icons-material";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const handleContactClick = (type) => {
    switch (type) {
      case "email":
        window.location.href = "mailto:support@gatewayinsurance.com";
        break;
      case "phone":
        window.location.href = "tel:+911234567890";
        break;
      case "github":
        window.open("https://github.com", "_blank");
        break;
      case "linkedin":
        window.open("https://linkedin.com", "_blank");
        break;
      default:
        break;
    }
  };

  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        background: "#000000",
        borderTop: "1px solid rgba(253, 184, 19, 0.1)",
        py: 4,
        position: "relative",
        zIndex: 100,
        overflow: "hidden"
      }}
    >
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr auto 1fr" },
          alignItems: "center",
          gap: { xs: 3, md: 0 },
          width: "100%",
          maxWidth: "1400px",
          mx: "auto",
          px: { xs: 3, md: 4 }
        }}
      >
        {/* Left Column */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: { xs: "center", md: "flex-start" },
            gap: 1
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontFamily: "'Outfit', sans-serif",
              fontWeight: 800,
              background: "linear-gradient(90deg, #ffffff, #FDB813)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            }}
          >
            GateWay Insurance
          </Typography>

          <Typography
            variant="body2"
            sx={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: 12,
              color: "rgba(255,255,255,0.6)"
            }}
          >
            © 2029 All rights reserved. v2.0
          </Typography>
        </Box>

        {/* Center Column */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            order: { xs: 2, md: 2 }
          }}
        >
          {[
            { icon: <EmailIcon />, tooltip: "Email", type: "email" },
            { icon: <PhoneIcon />, tooltip: "Phone", type: "phone" },
            { icon: <GitHubIcon />, tooltip: "GitHub", type: "github" },
            { icon: <LinkedInIcon />, tooltip: "LinkedIn", type: "linkedin" }
          ].map((item, index) => (
            <Tooltip
              key={index}
              title={item.tooltip}
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    fontFamily: "'Poppins', sans-serif",
                  }
                }
              }}
            >
              <IconButton
                onClick={() => handleContactClick(item.type)}
                sx={{
                  color: "rgba(255,255,255,0.7)",
                  width: 40,
                  height: 40,
                  "&:hover": {
                    color: "#FDB813",
                    transform: "translateY(-3px)",
                    boxShadow: "0 5px 15px rgba(253, 184, 19, 0.2)"
                  }
                }}
              >
                {item.icon}
              </IconButton>
            </Tooltip>
          ))}
        </Box>

        {/* ✅ Right Column – 2x2 Grid */}
        <Box
          sx={{
            display: { xs: "none", md: "grid" },
            gridTemplateColumns: "repeat(4, auto)",
            gap: 1.8,
            justifyContent: "end",
            textAlign: "right"
          }}
        >
          {[
            { label: "- Privacy Policy", href: "#" },
            { label: "- Terms of Service", href: "#" },
            { label: "- Cookie Policy", href: "#" },
            { label: "- Documentation", href: "#" }
          ].map((link, index) => (
            <Typography
              key={index}
              variant="body2"
              sx={{
                fontFamily: "'Poppins', sans-serif",
                fontSize: 12,
                color: "rgba(255,255,255,0.6)",
                cursor: "pointer",
                transition: "all 0.3s",
                "&:hover": {
                  color: "#FDB813",
                  transform: "translateX(-5px)"
                }
              }}
              onClick={() => window.open(link.href, "_self")}
            >
              {link.label}
            </Typography>
          ))}
        </Box>
      </Box>

      <Typography
        variant="caption"
        sx={{
          fontFamily: "'Poppins', sans-serif",
          display: "block",
          textAlign: "center",
          mt: 3,
          fontSize: 10,
          color: "rgba(255,255,255,0.4)"
        }}
      >
        Designed with ❤️ for GateWay Insurance Management System
      </Typography>
    </Box>
  );
}